import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import NumberPDFPagesImagesListScreen from "./NumberPDFPagesImagesListScreen";
import { BASE_URL } from "../Config";

function NumberPDFPagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Add Page Numbers To PDF File" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/number_pdf_pages",
      title: "Add Page Numbers To PDF Online",
    },
    data2: { link: "/number_pdf_pages", title: "Number PDF Pages" },
    data3: {
      link: "/number_pdf_pages",
      title: "Number Pages in PDF File Free",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Add page numbers to PDF files online easily. Number PDF pages quickly and organize documents with our fast and secure PDF numbering tool."
      ></meta>
      <meta
        name="keywords"
        content="number pdf pages, add page numbers to pdf, pdf page numbering, pdf page number tool, insert page numbers pdf, number pages in pdf, pdf editor online, pdf management tool, add pagination to pdf, online pdf numbering, pdf page editor, number pdf online, pdf numbering tool, page numbers pdf, pdf organizer"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <NumberPDFPagesImagesListScreen
          title={title}
        ></NumberPDFPagesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Add Page Numbers to PDF website offers a simple, secure, and efficient way to organize PDF documents by adding page numbers without requiring an internet connection. Designed to work fully offline, this powerful tool allows users to number PDF pages directly on their device, ensuring complete privacy and data protection. Whether you are working with study materials, legal documents, reports, or eBooks, adding clear and consistent page numbers improves readability and navigation. With this offline-capable solution, you can easily add page numbers to PDF, customize their position, style, and format, and instantly update your document without uploading files to a server. The website also supports advanced numbering options, making it easy to add page index to PDF files for professional presentation. Users who prefer online functionality can also number pages in PDF online when needed, while enjoying the flexibility of offline processing. Optimized for speed and accuracy, the tool preserves original text quality, layout, and formatting while numbering pages efficiently. Ideal for students, professionals, educators, and businesses, this website provides a reliable way to number PDF pages, organize long documents, and prepare files for printing or sharing. If you are looking for a secure, fast, and user-friendly solution to add page numbers to PDF, number PDF pages, or add page index to PDF with offline support, this platform delivers a seamless experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Add Numbers",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Number PDF Pages"
            why_use={[
              {
                title: "Improve Document Navigation",
                description:
                  "This number PDF pages tool adds clear page numbers, making it easier to navigate and reference long PDF documents.",
              },
              {
                title: "Professional and Organized Documents",
                description:
                  "Reports, assignments, and legal files look more professional when you add page numbers to PDF documents.",
              },
              {
                title: "Essential for Printing and Binding",
                description:
                  "Page numbering is crucial for printing and binding. A number pages in PDF online or offline tool ensures correct page order.",
              },
              {
                title: "Create a Page Index for Easy Reference",
                description:
                  "Using a tool to add page index to PDF helps readers quickly find specific sections or chapters.",
              },
              {
                title: "Save Time with Automatic Numbering",
                description:
                  "Our number PDF pages tool automatically adds page numbers, saving time compared to manual editing.",
              },
              {
                title: "Preserve Original Layout and Quality",
                description:
                  "When you add page numbers to PDF, modern tools maintain the original text, images, and formatting.",
              },
              {
                title: "Offline Processing for Better Privacy",
                description:
                  "Our offline add page numbers to PDF tool keeps your documents secure by processing files directly on your device.",
              },
              {
                title: "Helpful for Students and Educators",
                description:
                  "Students and teachers use number PDF pages tools for assignments, notes, and academic documents.",
              },
              {
                title: "Ideal for Business and Legal Documents",
                description:
                  "Business reports and legal PDFs require consistent numbering. This number pages in PDF online tool ensures accuracy.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default NumberPDFPagesMain;
